module.exports = __webpack_public_path__ + "img/logo_rambler_ru.af8dcddc.svg";